<template>
  <div class="megafon-body">
    <div class="head bg-orange">
      <div class="relative container">
        <h1>На край света с кэшбеком</h1>
      </div>
    </div>
    <div class="bg-orange two-block">
      <div class="container">
        <div class="text-center text mb-5">Как выгодней купить тур, когда ждать «горящих» предложений и возможно ли оставаться на связи за рубежом на домашних условиях – узнала наш корреспондент.</div>
        <div class="text my-5">Лето – всегда «горячая» пора для туристов. На море, в пустыню, к экзотическим водопадам или в джунгли – какое направление для путешествия выбрать?</div>
        <div class="red-head">
          Куда летают<br> абоненты МегаФона<br> в Тамбове летом
        </div>
        <div class="map">
          <img src="../assets/map.png" alt="">
        </div>
        <div class="city">
          <span class="turkey">Турция</span> • <span class="abhaz">Абхазия</span> • <span class="urk">Украина</span> • <span class="kaz">Казахстан</span> • <span class="gruz">Грузия</span> • <span class="kipr">Кипр</span> • <span class="spain">Испания</span> • <span class="bel">Беларусь</span>
        </div>
        <div class="city-descr">
          На карте представлены Топ-10 летних направлений у абонентов МегаФона в Тамбове в 2018 г
        </div>
        <div class="text-small">
          <p>
            Стоимость курорта прямо пропорциональна его сезонности. Чем ближе лето, тем выше цены на отдых в Турции, Греции, Испании, Италии, Болгарии, на Мальте и пр. При этом на некоторые популярные направления цены, наоборот, падают. В ряде курортов Азии и Южной Америки в это время начинается сезон проливных дождей.
          </p>
          <p>
            В странах карибского бассейна возможны ураганы. В большинстве Арабских стран летом царит сильная жара,перенести которую может далеко не каждый.Есть еще одна хитрость: в самый разгар сезона отпусков стоимость туров выше, чем в межсезонье. Например, 12 дней в Турции в мае или в сентябре будут стоить на порядок дешевле, чем в июле. Кто-то покупает туры задолго до отпуска, руководствуясь предложениями «раннего бронирования», кто-то ждет «горящих» туров.
          </p>
          <p>
            Желание сэкономить и отдохнуть с максимальным комфортом свойственно почти всем туристам. Вопрос в том, как «урвать» лучшее предложение.
          </p>
          <p>
            Отчего зависит стоимость тура? В один «пакет» туристические операторы «упаковывают» перелет, проживание,трансферт, медицинскую страховку. Поставщики услуг получают свои бонусы в виде специальных скидок на отели и перелет, потому самостоятельные путешествия в другую страну часто выходят на порядок дороже. Давайте разберемся: как сэкономить на покупке тура. Его стоимость может меняться в зависимости от сезонности курорта, времени покупки и спецпредложений от оператора.
          </p>
          <p>
            Как найти «золотую» середину и сэкономить на покупке билетов? Туроператоры имеют свою розничную сеть продаж, а также заключают контракты с агентствами. Посредники чаще всего работают сразу с несколькими операторами, которые ставят им жесткие рамки.
          </p>
        </div>
        <div class="fly-block fly-purple">
          <div class="fly-text">

          <div class="fly-block-head">© Марина Барабан, директор туристического агентства «Best Travel»</div>
          <div class="fly-block-descr">«Часто сталкиваюсь с тем, что в выгодного тура, клиенты оставляют заявки менеджерам разных агентств. Необходимости в этом нет. Дело в том, что стоимость тура уже включает агентский процент, который устанавливает оператор. Он для всех одинаковый, а потому большой разницы в цене вы не заметите. Все операторы перешли на динамическое ценообразование, а это значит, стоимость тура может снижаться или увеличиваться даже в течение дня в зависимости от спроса и прочих факторов. Поэтому для вашего же комфорта выберите ту точку продаж, где вам удобнее всего приобретать туры»
          </div>
          </div>
        </div>
       
        <div class="text-small">
          <p>
            При этом за качество отдыха отвечает не посредник, а оператор – компания, которая «упаковывала» продукт. Какие сегодня варианты экономии есть у путешественников? Большинство агентств советуют приобретать тур заранее. Возможность раннего бронирования открывается в среднем за 3-6 месяцев до поездки. Однако на некоторые туры продажи начинаются задолго до дня вылета.
          </p>
          <p>
            «Горящие» туры – это те предложения, на которые, скрестив пальцы, надеются многие. Чаще всего – это финальная распродажа от оператора. А потому не нужно ждать ассортимента отелей. В самый разгар времени отпусков на такие предложения надеяться тоже не стоит. Чаще всего они появляются в межсезонье или не в сезон. Бывает, что туроператоры предлагают «горящие» туры в середине мая - после праздников, когда впреддверии лета падает спрос. Минус в том, что дату, когда такие предложения появятся, нельзя «вычислить», а потому путевка по специальной цене – скорее «лотерея»: совпадет ли отпуск, есть ли виза и пр.
          </p>
        </div>
         <div class="fly-block fly-red">
           <div class="fly-text">

          <div class="fly-block-head">© Алексей Иванов, руководитель турагентства «Путевка Маркет»</div>
          <div class="fly-block-descr">«В сезон обычно все хорошие отели по приятной цене уже забронированы. Потому оператор может уменьшитьстоимость путевки на менее ликвидные варианты жилья. При бронировании заранее туристы порой даже не рассматривают такие отели, потому что есть более выгодные предложения с максимально комфортными условиями. Кроме того, при раннем бронировании можно выгадать до 30% от стоимости тура. Почему так происходит? Оператор заранее бронирует квоту мест в отелях и на чартерных рейсах. Чтобы компенсировать расходы, в первые дни продаж оператор значительно понижает стоимость туров»</div>
        </div>
           </div>
        
        <div class="text-small">
          <p>
            Тем, кто привык планировать отдых заранее, есть отличный лайфхак – скачайте приложение-агрегатор предложений одновременно нескольких туроператоров. У большинства функционал включает календарь актуальных на сегодняшний день цен на год – так вы найдете самый выгодный тур. Приложений-агрегаторов сегодня десятки – достаточно ввести запрос в плей-маркете. Отличие чаще всего в функционале. У одних есть возможность бронировать экскурсии, другие предлагают еще и приобрести авиаперелеты. Есть и сервисы с гарантированной выгодой.
          </p>
        </div>
        <div class="fly-block fly-green">
          <div class="fly-text">

          <div class="fly-block-head">© Сергей Назаров, директор регионального отделения «МегаФона» в Тамбове</div>
          <div class="fly-block-descr">«Мы создали для наших абонентов простой онлайн-агрегатор лучших предложений Библио-Глобуса, Tui, TezTour и других туроператоров «МегаФон Путешествия». Здесь можно в два клика приобрести тур,забронировать отель, арендовать автомобиль, оплатить медицинскую страховку,заказать экскурсию. Выгода – в кэшбэке: наши клиенты могут вернуть до 9% от стоимости покупки на счет мобильного. Это «живые» деньги, их можно снять в банкомате или потратить на покупки в любом магазине. Приятная новость для путешественников: в июле мы отмечаем первую годовщину сервиса и в течении всего месяца наши абонентысмогут пользоваться ресурсом с еще большей выгодой. С 1 июля мы на четверть увеличиваем процентные ставки кэшбэка по услугам ресурса»</div>
          </div>
        </div>
      </div>
    </div>
    <div class="third-block">
      <div class="container">
        <div class="buy-head">Покупайте с выгодой</div>
        <div class="buy-descr">
          Сервис доступен для всех. Если вы абонент МегаФона <a class="link link_theme_standard" href="https://life.megafon.ru/login">авторизуйтесь</a>, чтобы получить кэшбэк
        </div>
        <div class="section__body">
          <ul class="list cashback-category-grid cashback-category-grid_promo">
              <li class="list__item cashback-category-grid__cell">
                  <div class="tile tile_theme_standard tile_promo cashback-category-tile">
                      <div class="tile__content">
                          <span class="cashback-category-tile__icon tile__icon">
                              <svg class="svg-icon cashback-category-tile__svg-icon tile__svg-icon" width="40" height="40" focusable="false">
                                  <use xlink:href="#svg-symbol-plane-8d6cf346fd62f8e24732198e6feff7c9">
                                  </use>
                              </svg>
                          </span>
                          <h3 class="tile__title">
                              <a class="link tile__title-text" href="https://travel.megafon.ru/flights">Авиабилеты</a>
                          </h3>
                          <p class="tile__description">Билеты в&nbsp;любую точку мира от&nbsp;самых популярных авиакасс и&nbsp;агентств бронирования</p>
                      </div>
                      <div class="cashback-amount cashback-amount_promo cashback-category-tile__amount">
                          <p class="cashback-amount__text">Кэшбэк для абонентов</p>
                          <p class="cashback-amount__wrapper">
                              <span class="cashback-amount__old-value">1%</span>
                              <span class="cashback-amount__current-value tile__highlight">1,3%</span>
                          </p>
                      </div>
                  </div>
              </li>
              <li class="list__item cashback-category-grid__cell">
                  <div class="tile tile_theme_standard tile_promo cashback-category-tile">
                      <div class="tile__content">
                          <span class="cashback-category-tile__icon tile__icon">
                              <svg class="svg-icon cashback-category-tile__svg-icon tile__svg-icon" width="40" height="40" focusable="false">
                                  <use xlink:href="#svg-symbol-hotel-b844e2acaca36e0fb290817ff5f81648">
                                  </use>
                              </svg>
                          </span>
                          <h3 class="tile__title">
                              <a class="link tile__title-text" href="https://travel.megafon.ru/hotels">Отели</a>
                          </h3>
                          <p class="tile__description">Отели, хостелы, апартаменты по&nbsp;всему миру. Предложения от&nbsp;70+ агентств бронирования</p>
                      </div>
                      <div class="cashback-amount cashback-amount_promo cashback-category-tile__amount">
                          <p class="cashback-amount__text">Кэшбэк для абонентов</p>
                          <p class="cashback-amount__wrapper">
                              <span class="cashback-amount__old-value">2,7%</span>
                              <span class="cashback-amount__current-value tile__highlight">3,4%</span>
                          </p>
                      </div>
                  </div>
              </li>
              <li class="list__item cashback-category-grid__cell">
                  <div class="tile tile_theme_standard tile_promo cashback-category-tile">
                      <div class="tile__content">
                          <span class="cashback-category-tile__icon tile__icon">
                              <svg class="svg-icon cashback-category-tile__svg-icon tile__svg-icon" width="40" height="40" focusable="false">
                                  <use xlink:href="#svg-symbol-railway-02acddafb3543c73461c42498d2e68de">
                                  </use>
                              </svg>
                          </span>
                          <h3 class="tile__title">
                              <a class="link tile__title-text" href="https://travel.megafon.ru/trains">Ж/д билеты</a>
                          </h3>
                          <p class="tile__description">Билеты на&nbsp;поезд по&nbsp;самым выгодным ценам, не&nbsp;выходя из&nbsp;дома</p>
                      </div>
                      <div class="cashback-amount cashback-amount_promo cashback-category-tile__amount">
                          <p class="cashback-amount__text">Кэшбэк для абонентов</p>
                          <p class="cashback-amount__wrapper">
                              <span class="cashback-amount__old-value">3%</span>
                              <span class="cashback-amount__current-value tile__highlight">3,7%</span>
                          </p>
                      </div>
                  </div>
              </li>
              <li class="list__item cashback-category-grid__cell">
                  <div class="tile tile_theme_standard tile_promo cashback-category-tile">
                      <div class="tile__content">
                          <span class="cashback-category-tile__icon tile__icon">
                              <svg class="svg-icon cashback-category-tile__svg-icon tile__svg-icon" width="40" height="40" focusable="false">
                                  <use xlink:href="#svg-symbol-tours-31d901a3a8ccd5d61f7c3b73a140c864">
                                  </use>
                              </svg>
                          </span>
                          <h3 class="tile__title">
                              <a class="link tile__title-text" href="https://travel.megafon.ru/tours">Туры</a>
                          </h3>
                          <p class="tile__description">Туры онлайн, без утомительных поездок в&nbsp;офисы турфирм</p>
                      </div>
                      <div class="cashback-amount cashback-amount_promo cashback-category-tile__amount">
                          <p class="cashback-amount__text">Кэшбэк для абонентов</p>
                          <p class="cashback-amount__wrapper">
                              <span class="cashback-amount__old-value">1,9%</span>
                              <span class="cashback-amount__current-value tile__highlight">2,5%</span>
                          </p>
                      </div>
                  </div>
              </li>
              <li class="list__item cashback-category-grid__cell">
                  <div class="tile tile_theme_standard tile_promo cashback-category-tile">
                      <div class="tile__content">
                          <span class="cashback-category-tile__icon tile__icon">
                              <svg class="svg-icon cashback-category-tile__svg-icon tile__svg-icon" width="40" height="40" focusable="false">
                                  <use xlink:href="#svg-symbol-bus-8c47579076cb668212fe464a5b59e0af">
                                  </use>
                              </svg>
                          </span>
                          <h3 class="tile__title">
                              <a class="link tile__title-text" href="https://travel.megafon.ru/buses">Автобусы</a>
                          </h3>
                          <p class="tile__description">Онлайн билеты на&nbsp;автобусы в&nbsp;города России и&nbsp;за&nbsp;рубеж</p>
                      </div>
                      <div class="cashback-amount cashback-amount_promo cashback-category-tile__amount">
                          <p class="cashback-amount__text">Кэшбэк для абонентов</p>
                          <p class="cashback-amount__wrapper">
                              <span class="cashback-amount__old-value">5%</span>
                              <span class="cashback-amount__current-value tile__highlight">6,2%</span>
                          </p>
                      </div>
                  </div>
              </li>
              <li class="list__item cashback-category-grid__cell">
                  <div class="tile tile_theme_standard tile_promo cashback-category-tile">
                      <div class="tile__content">
                          <span class="cashback-category-tile__icon tile__icon">
                              <svg class="svg-icon cashback-category-tile__svg-icon tile__svg-icon" width="40" height="40" focusable="false">
                                  <use xlink:href="#svg-symbol-car-a2639bcc711fcff7870b44be77c5b2e1">
                                  </use>
                              </svg>
                          </span>
                          <h3 class="tile__title">
                              <a class="link tile__title-text" href="https://travel.megafon.ru/transfer">Трансферы</a>
                          </h3>
                          <p class="tile__description">Трансфер из/в аэропорт в&nbsp;чужой стране, подается заранее и&nbsp;ожидает ваш рейс</p>
                      </div>
                      <div class="cashback-amount cashback-amount_promo cashback-category-tile__amount">
                          <p class="cashback-amount__text">Кэшбэк для абонентов</p>
                          <p class="cashback-amount__wrapper">
                              <span class="cashback-amount__old-value">6%</span>
                              <span class="cashback-amount__current-value tile__highlight">7,5%</span>
                          </p>
                      </div>
                  </div>
              </li>
              <li class="list__item cashback-category-grid__cell">
                  <div class="tile tile_theme_standard tile_promo cashback-category-tile">
                      <div class="tile__content">
                          <span class="cashback-category-tile__icon tile__icon">
                              <svg class="svg-icon cashback-category-tile__svg-icon tile__svg-icon" width="40" height="40" focusable="false">
                                  <use xlink:href="#svg-symbol-museum-446eb6b7d2a58be3f7280d1ce1e47ff4">
                                  </use>
                              </svg>
                          </span>
                          <h3 class="tile__title">
                              <a class="link tile__title-text" href="https://travel.megafon.ru/activities">Экскурсии</a>
                          </h3>
                          <p class="tile__description">Экскурсии в&nbsp;400+ городах мира, индивидуальные и&nbsp;групповые</p>
                      </div>
                      <div class="cashback-amount cashback-amount_promo cashback-category-tile__amount">
                          <p class="cashback-amount__text">Кэшбэк для абонентов</p>
                          <p class="cashback-amount__wrapper">
                              <span class="cashback-amount__old-value">6%</span>
                              <span class="cashback-amount__current-value tile__highlight">7,5%</span>
                          </p>
                      </div>
                  </div>
              </li>
              <li class="list__item cashback-category-grid__cell">
                  <div class="tile tile_theme_standard tile_promo cashback-category-tile">
                      <div class="tile__content">
                          <span class="cashback-category-tile__icon tile__icon">
                              <svg class="svg-icon cashback-category-tile__svg-icon tile__svg-icon" width="40" height="40" focusable="false">
                                  <use xlink:href="#svg-symbol-insurance-5b4f002572ae9ca61f23e10cf2d10250">
                                  </use>
                              </svg>
                          </span>
                          <h3 class="tile__title">
                              <a class="link tile__title-text" href="https://travel.megafon.ru/insurance">Страховка</a>
                          </h3>
                          <p class="tile__description">Страховки для путешествий с&nbsp;возможностью сравнения предложений от&nbsp;разных компаний</p>
                      </div>
                      <div class="cashback-amount cashback-amount_promo cashback-category-tile__amount">
                          <p class="cashback-amount__text">Кэшбэк для абонентов</p>
                          <p class="cashback-amount__wrapper">
                              <span class="cashback-amount__old-value">9%</span>
                              <span class="cashback-amount__current-value tile__highlight">11%</span>
                          </p>
                      </div>
                  </div>
              </li>
          </ul>
      </div>
      </div>
    </div>
    <div class="bg-orange bg-footer">
      <div class="container py-5">
        <div class="purple-head">
          ШПАРГАЛКА ТУРИСТУ: ПОЛЕЗНО ЗА РУБЕЖОМ
        </div>
        <div class="text-small">
          <p class="bold">
            Лайфхак 1
          </p>
          <p>
            Если вы летите в новую страну впервые, скачайте для удобства офлайн-карту населенного пункта, который вам необходим, например, Maps me. Минус в том, что без доступа в интернет в приложении у вас будет ограниченный доступ к маршрутам новой для вас страны (только те карты, которые вы скачали заранее).
          </p>
          <br>
          <p class="bold">
            Лайфхак 2
          </p>
          <p>
            Спланируйте заранее экскурсии, которые вам интересно посетить. Для этого лучше заранее изучить географию достопримечательностей курорта – это можно сделать на сайте <a href="https://experience.tripster.ru/" >Tripster</a>. А если вы – абонент МегаФона, то бронируйте экскурсию через сервис <a href="https://travel.megafon.ru/activities">«МегаФон Путешествия»</a>, который как раз работает с Tripster, - так вы получите кэшбэк 6%.
          </p>
          <br>
          <p class="bold">
            Лайфхак 3
          </p>
          <p>
            Подумайте о том, как оставаться на связи за рубежом, чтобы родные и близкие не беспокоились, а коллеги могли решить срочный вопрос с вами. Бывают ситуации, когда нужно срочно решить важный вопрос по телефону, а цены в роуминге «кусаются». С какой услугой общение за рубежом будет выгодней? Среди лучших – опция <a href="https://moscow.megafon.ru/roaming/world/">«Роуминг, гудбай!»</a> МегаФона. С ней можно пользоваться интернетом и звонить целый день по условиям вашего тарифа в домашнем регионе, ее стоимость от 189 до 349 р (в зависимости от страны, в которой вы находитесь, - в списке 100 популярных направлений). Это значит, что на пляже, на экскурсии или в ресторане вы сможете поделиться впечатлениями, не думая о роуминге. Удобство в том, что опция автоматически подключается, как только вы воспользуетесь услугами связи за рубежом и действует в течение дня. Как только вы вернетесь в Россию, опция автоматически перестанет действовать.
          </p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<style src="./style.css" scoped></style>